export const siteUrl = process.env.REACT_APP_SITE_URL || "https://гостим.рф";
export const apiUrl = process.env.REACT_APP_API_URL || "https://api.gostim.ru";

export const photoUrl = "https://storage.yandexcloud.net/gostim-photo";
export const mapApiKey = "e468af10-c28a-493a-a636-5e330a92f16b";

export const FURNITURE_TYPES = [
  { value: "folding_bed", label: "Раскладная кровать" },
  { value: "cot", label: "Раскладушка" },
  { value: "sofa", label: "Диван" },
  { value: "sofa_chair", label: "Кресло-кровать" },
  { value: "baby_crib", label: "Детская кроватка" },
];

export const furnitureTypesObject = {
  folding_bed: "Раскладная кровать",
  cot: "Раскладушка",
  sofa: "Диван",
  sofa_chair: "Кресло-кровать",
  baby_crib: "Детская кроватка",
};

export const maxGuests = 6;
export const maxChildren = 4;
